import { render } from "./gantt_chart.svg?vue&type=template&id=2a792532"
const script = {}
script.render = render

export default script